import React, { memo, useContext, useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { OEContext } from '@aytm/app/stats/page/comments'

import { InputSwitch } from 'primereact/inputswitch'

import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

import style from '@aytm/app/stats/page/comments/comments/styles/Response.module.scss'

const Translation = memo(({ response, responseTranslation, setResponseTranslation }) => {
  const { translation } = useContext(OEContext)

  const responseLanguage = useMemo(
    () =>
      Object.hasOwn(response, 'trait') && Object.hasOwn(response.trait, 'locale')
        ? response.trait.locale.split('_')[0].toLowerCase()
        : '*',
    [response]
  )

  const currentTranslation = useMemo(
    () =>
      Object.hasOwn(response, 'extra') &&
      Object.hasOwn(response.extra, 'answer') &&
      Object.hasOwn(response.extra.answer, responseTranslation || translation)
        ? responseTranslation || translation
        : '*',
    [translation, response, responseTranslation]
  )

  const isDisabled = useMemo(
    () =>
      !Object.hasOwn(response, 'extra') ||
      !Object.hasOwn(response.extra, 'answer') ||
      !Object.hasOwn(response.extra.answer, translation),
    [response, translation]
  )

  useEffect(() => setResponseTranslation(null), [translation, setResponseTranslation])

  return '*' != translation && translation != responseLanguage ? (
    <div className={style['response-header-translation']}>
      <span
        className={classNames(style['response-header-translation-item'], {
          [style['response-header-translation-item-active']]: translation != currentTranslation
        })}
        onClick={isDisabled ? null : () => setResponseTranslation('*')}
      >
        <span className={style['response-header-translation-item-icon']}>
          <i className="icon-aytmfd-translate" />
        </span>
      </span>
      <InputSwitch
        checked={translation == currentTranslation}
        disabled={isDisabled}
        onChange={isDisabled ? null : event => setResponseTranslation(event.value ? translation : '*')}
      />
      <span
        className={classNames(style['response-header-translation-item'], {
          [style['response-header-translation-item-active']]: translation == currentTranslation,
          [style['response-header-translation-item-disabled']]: isDisabled
        })}
        onClick={isDisabled ? null : () => setResponseTranslation(translation)}
      >
        {isDisabled ? (
          <Popup
            className={style['response-header-popup']}
            targetClassName="p-field p-col-12"
            width="270px"
            trigger="hover"
            direction="bottomleft"
            popupOffset={11}
            content={() => (
              <div className={style['response-header-popup-content']}>
                <span className={style['response-header-popup-icon']}>
                  <i className="icon-aytmfd-skipper" />
                </span>
                <span>
                  <b>Work in progress!</b>
                  <br />
                  Translating to <b>{translation.toUpperCase()}</b>
                  <br />
                  Please check back in a few
                </span>
              </div>
            )}
          >
            <span className={style['response-header-translation-item-icon']}>
              <i className="icon-aytmfd-skipper" />
            </span>
          </Popup>
        ) : (
          <span className={style['response-header-translation-item-text']}>
            <b>{translation.toUpperCase()}</b>
          </span>
        )}
      </span>
    </div>
  ) : null
})

Translation.propTypes = {
  response: PropTypes.object,
  responseTranslation: PropTypes.string,
  setResponseTranslation: PropTypes.func
}

Translation.displayName = 'Translation'

export default Translation
